<template>
  <generic-modal :title="$t('movement')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('movement type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="type_changed"
            ref="type_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("amount") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.amount" />
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "MovementModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.amount || !v.meta.type_id /* || !v.meta.sale_price */;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(account_uuid) {
      let v = this;
      v.set_initial_state();
      v.meta.account_uuid = account_uuid;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      put("/account/movement", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        amount: "",
        type_id: "",
        settings: {},
      };
      v.$refs.type_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    type_changed(type) {
      let v = this;
      if (type) v.meta.type_id = type.movement_type_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
